import { render, staticRenderFns } from "./BCListBox.vue?vue&type=template&id=7056818a&scoped=true"
import script from "./BCListBox.vue?vue&type=script&lang=js"
export * from "./BCListBox.vue?vue&type=script&lang=js"
import style0 from "./BCListBox.vue?vue&type=style&index=0&id=7056818a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7056818a",
  null
  
)

export default component.exports